import {SMALL_MODAL, REPORT_NAME} from './types'
import {report} from '../../../api/api-endpoints'
import region from '../../../utils/region.js'

import {cardClassWithOutApo} from "./types"

const configDataDefault = {
  1: {
    id: REPORT_NAME.ACT_RECONCILIATION, // 1001
    title: 'Акт сверки',
    windowType: SMALL_MODAL,
    col: 1,
    endpoint: report.reconciliation,
    cardClass: cardClassWithOutApo
  },
  2: {
    id: REPORT_NAME.COLLECTION, // 1002
    title: 'Отчет по собираемости',
    windowType:  SMALL_MODAL,
    col: 2,
    endpoint: report.collection,
    cardClass:  cardClassWithOutApo
  },
  3: {
    isEmpty: true,
    col: 3
  },
  4: {
    isEmpty: true,
    col: 4
  }
}

const configData = {
  default: configDataDefault
}

export default region.getRegionConfig(configData)
